import { render, staticRenderFns } from "./CreatorsSlider.vue?vue&type=template&id=3bebd506&scoped=true&"
import script from "./CreatorsSlider.vue?vue&type=script&lang=ts&"
export * from "./CreatorsSlider.vue?vue&type=script&lang=ts&"
import style0 from "./CreatorsSlider.vue?vue&type=style&index=0&id=3bebd506&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bebd506",
  null
  
)

export default component.exports